import script from "./ListarConfiguracoesCobrancas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarConfiguracoesCobrancas.vue?vue&type=script&setup=true&lang=js"

import "./ListarConfiguracoesCobrancas.vue?vue&type=style&index=0&id=99be4588&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99be4588"]])

export default __exports__